<div class="row" id="myTopnav">
  <a
    (click)="shared.onClick(1)"
    routerLink="/home"
    class="active navbar-ellipsis"
    id="dash"
    >home</a
  >
  <a
    (click)="shared.onClick(10)"
    routerLink="/createNewLesson"
    [queryParams]="{ lessonWorkflowType: extensionType.standardFEWorkflow }"
    class="navbar-ellipsis"
    >create new lesson</a
  >
  <a
    id="lessonslearned"
    (click)="shared.onClick(3)"
    routerLink="/lessons"
    class="navbar-ellipsis"
    >view lessons</a
  >
  <a
    (click)="onClick(4)"
    routerLink="/lessons"
    class="navbar-ellipsis pendingTasksLink"
    >your actions
    @if (pendingTasks > 0) {
    <span class="pendingTasksBadge">{{ pendingTasksBadge }}</span>
    }</a
  >
  <a (click)="shared.onClick(5)" routerLink="/report" class="navbar-ellipsis"
    >metrics</a
  >
  @if (showReportedLessonsTab) {
  <a (click)="onClick(7)" routerLink="/reportedLessons" class="navbar-ellipsis"
    >reported lessons</a
  >
  }
  <!-- <a
    (click)="shared.onClick(8)"
    routerLink="/projectLookbackView"
    class="navbar-ellipsis"
    >lookback dashboard</a
  > --><!--TEMPORARILY REMOVED UNTIL PLB SUPPORTS STANDARDIZED WORKFLOW-->
  @if (showCoordinatorTab) {
  <a
    (click)="shared.onClick(9)"
    routerLink="/coordinatorDashboard"
    class="navbar-ellipsis"
    >coordinator dashboard</a
  >
  } @if (showAdminPortalTab) {
  <a
    (click)="shared.onClick(10)"
    routerLink="/adminPortal"
    class="navbar-ellipsis"
    >admin portal</a
  >
  }
</div>
